import React from "react";

const TabBoletines = ({
  handleSubmitBoletin,
  formData,
  handleInputChangeBoletin,
  handleFileChangeBoletin,
  newsletter,
  handleOpenDeleteModal,
  handleViewBoletin,
  isViewModalOpen,
  selectedBoletin,
  handleOpenPDF,
  handleCloseViewModal,
  API_URL,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
        {/* Formulario de registro */}
        <div className="sm:col-span-1 flex justify-center w-full tamanoConenedor scrollbar styleScrollbar margenResultado">
          <form
            onSubmit={handleSubmitBoletin}
            className="md:max-w-md max-w-xs mx-auto mt-5 border border-gray-200 rounded-lg p-6 shadow-md"
          >
            <div className="">
              <div className="flex justify-center mb-6">
                <label className="text-2xl font-semibold text-[#1E429F] flex items-center">
                  <i className="bx bxs-bookmark-plus text-[#1E429F] mr-2"></i>{" "}
                  Registro de Newsletter
                </label>
              </div>

              {/* Campo de Nombre */}
              <div className="mb-6">
                <div className="text-center mb-1">
                  <label className="text-sm font-medium text-gray-700">
                    Nombre
                  </label>
                </div>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChangeBoletin}
                  className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                  placeholder="Nombre del boletín"
                  required
                />
              </div>

              {/* Campo de Archivo PDF */}
              <div className="mb-6">
                <div className="text-center mb-1">
                  <label className="text-sm font-medium text-gray-700">
                    Archivo PDF
                  </label>
                </div>
                <div className="flex items-center bg-gray-50 rounded-xl p-2">
                  <button
                    type="button"
                    onClick={() =>
                      document.getElementById("pdf-upload").click()
                    }
                    className="bg-white border border-gray-200 text-gray-700 px-4 py-2.5 text-sm rounded-lg flex items-center hover:bg-gray-100 transition-colors"
                  >
                    <i className="bx bx-upload mr-2 text-blue-600"></i>
                    {formData.url_pdf ? "Cambiar archivo" : "Seleccionar PDF"}
                  </button>
                  <span className="ml-3 text-sm text-gray-500 overflow-hidden whitespace-nowrap overflow-ellipsis flex-1">
                    {formData.url_pdf
                      ? formData.url_pdf.name
                      : "Ningún archivo seleccionado"}
                  </span>
                  <input
                    id="pdf-upload"
                    type="file"
                    name="url_pdf"
                    accept="application/pdf"
                    onChange={handleFileChangeBoletin}
                    className="hidden"
                    required
                  />
                </div>
              </div>

              {/* Campo de Imagen */}
              <div className="mb-6">
                <div className="text-center mb-1">
                  <label className="text-sm font-medium text-gray-700">
                    Imagen
                  </label>
                </div>
                <div className="flex items-center bg-gray-50 rounded-xl p-2">
                  <button
                    type="button"
                    onClick={() =>
                      document.getElementById("image-upload").click()
                    }
                    className="bg-white border border-gray-200 text-gray-700 px-4 py-2.5 text-sm rounded-lg flex items-center hover:bg-gray-100 transition-colors"
                  >
                    <i className="bx bx-image mr-2 text-blue-600"></i>
                    {formData.imagen ? "Cambiar imagen" : "Seleccionar imagen"}
                  </button>
                  <span className="ml-3 text-sm text-gray-500 overflow-hidden whitespace-nowrap overflow-ellipsis flex-1">
                    {formData.imagen
                      ? formData.imagen.name
                      : "Ninguna imagen seleccionada"}
                  </span>
                  <input
                    id="image-upload"
                    type="file"
                    name="imagen"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleFileChangeBoletin}
                    className="hidden"
                    required
                  />
                </div>
              </div>

              {/* Campo de Descripción */}
              <div className="mb-6">
                <div className="text-center mb-1">
                  <label className="text-sm font-medium text-gray-700">
                    Descripción
                  </label>
                </div>
                <textarea
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleInputChangeBoletin}
                  className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm resize-none"
                  rows="3"
                  placeholder="Describe el contenido del boletín..."
                  required
                />
              </div>

              <button
                type="submit"
                className="text-white w-full bg-blue-800 hover:bg-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center"
              >
                <i className="bx bxs-save text-white mr-2"></i> Registrar
              </button>
            </div>
          </form>
        </div>

        {/* Tabla de boletines */}
        <div className="sm:col-span-1 flex justify-center w-full tamanoConenedor scrollbar styleScrollbar margenResultado">
          <div className="flex flex-col w-full">
            <h3 className="text-xl font-semibold text-[#1E429F] mb-3 flex items-center justify-center">
              <i className="bx bxs-news text-[#1E429F] mr-2"></i> Boletines
              registrados
            </h3>
            <div className="w-full overflow-x-auto">
              <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
                <thead className="bg-gray-100 border-b">
                  <tr>
                    <th className="w-1/12 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                      #
                    </th>
                    <th className="w-1/4 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                      Nombre
                    </th>
                    <th className="w-1/3 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                      Descripción
                    </th>
                    <th className="w-1/4 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                      Fecha registro
                    </th>
                    <th className="text-center font-semibold px-6 py-3 text-sm text-gray-700">
                      Acciones
                    </th>
                  </tr>
                </thead>
                <tbody className="text-gray-700 divide-y divide-gray-200">
                  {typeof newsletter !== "undefined" &&
                  Array.isArray(newsletter) &&
                  newsletter.length !== 0 ? (
                    newsletter.map((item) => (
                      <tr className="text-sm hover:bg-gray-50" key={item.id}>
                        <td className="text-center py-3 px-4">{item.id}</td>
                        <td className="text-center py-3 px-4">{item.nombre}</td>
                        <td className="text-center py-3 px-4">
                          {item.descripcion}
                        </td>
                        <td className="text-center py-3 px-4">
                          {item.fechaRegistro}
                        </td>
                        <td className="text-center py-3 px-4">
                          <div className="flex justify-center space-x-2">
                            {item.estatus === "1" ? (
                              <button
                                onClick={() => handleOpenDeleteModal(item)}
                                className="bg-red-600 hover:bg-red-700 rounded-md flex items-center justify-center text-white p-2 w-10 h-10"
                                title="Eliminar boletín"
                              >
                                <i className="bx bx-trash text-xl"></i>
                              </button>
                            ) : (
                              <button
                                className="bg-gray-200 rounded-md flex items-center justify-center text-gray-500 p-2 w-10 h-10 cursor-not-allowed"
                                disabled
                                title="No se puede eliminar"
                              >
                                <i className="bx bx-minus-circle text-xl"></i>
                              </button>
                            )}
                            <button
                              onClick={() => handleViewBoletin(item)}
                              className="bg-blue-600 hover:bg-blue-700 rounded-md flex items-center justify-center text-white p-2 w-10 h-10"
                              title="Ver boletín"
                            >
                              <i className="bx bx-show text-xl"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center py-4 text-gray-500"
                      >
                        No hay boletines registrados
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {isViewModalOpen && selectedBoletin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden w-full max-w-md mx-4">
            <div className="bg-blue-600 px-4 py-3 text-white flex items-center justify-center">
              <i className="bx bx-file text-2xl mr-2"></i>
              <h3 className="text-lg font-medium">Detalles del Boletín</h3>
            </div>
            <div className="p-6">
              <h2 className="text-xl font-bold text-center text-gray-800 mb-4">
                {selectedBoletin.nombre}
              </h2>

              {selectedBoletin.imagen && (
                <div className="flex justify-center mb-4 border border-gray-200 p-2">
                  <img
                    src={`${API_URL}${selectedBoletin.imagen}`}
                    alt={selectedBoletin.nombre}
                    className="max-h-64 object-contain"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        "https://via.placeholder.com/300x200?text=Imagen+no+disponible";
                    }}
                  />
                </div>
              )}

              <div className="mb-6">
                <h3 className="font-semibold text-gray-700 mb-2">
                  Descripción:
                </h3>
                <p className="text-gray-600">{selectedBoletin.descripcion}</p>
              </div>

              <div className="mb-6 text-sm text-gray-500 text-center">
                Fecha de registro: {selectedBoletin.fechaRegistro}
              </div>

              <div className="flex flex-col items-center mt-6 space-y-4">
                <button
                  onClick={handleOpenPDF}
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-md flex items-center"
                >
                  <i className="bx bx-file-pdf text-xl mr-2"></i>
                  Ver PDF
                </button>

                <button
                  onClick={handleCloseViewModal}
                  className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-md"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TabBoletines;
